import styled from '@emotion/styled';

const SecondaryTableCell = styled('td')(({ theme }) => ({
  color: theme.palette.text.secondary,
}));

export default SecondaryTableCell;
